import React, { useReducer } from 'react';
import type { FC, ReactNode } from 'react';
import { TransportTicketPickerContext as TransportTicketPickerContextInterface } from '../types/context/TransportTicketPickerContext';
import { transportTicketPickerReducer } from './transportTicketPickerReducer';

interface TransportTicketPickerProviderProps {
    children: ReactNode;
}
const initialState = {
    language: 'fr',
    transportMode: 'R'
};

export const TransportTicketPickerStore = React.createContext<TransportTicketPickerContextInterface>({ state: initialState, dispatch: () => null });
const { Provider } = TransportTicketPickerStore;

export const TransportTicketPickerProvider: FC<TransportTicketPickerProviderProps> = (props: TransportTicketPickerProviderProps) => {
    const { children } = props;

    const [state, dispatch] = useReducer(transportTicketPickerReducer, initialState);

    return <Provider value={{ state, dispatch }}>{children}</Provider>;
};
